import {MISSION_SCRIPT_KINDS} from '../../configs/campaigns/missionFormat';

/**
 * Сборка конфига миссии из состояния редактора — то, что уедет в JSON и
 * ляжет в код проекта.
 *
 * Картинки персонажей в конфиг попадают ОТНОСИТЕЛЬНЫМИ путями: сами файлы
 * автор кладёт в public/img/campaigns/<missionId>/ руками (см. инструкцию в
 * developer_artifacts/tasks/mission_editor.md).
 */
export const buildMissionConfig = (missionState) => {
  const draft = missionState.draft || {};

  // В ленте заменяем dataUrl превью на относительный путь картинки
  const script = (missionState.script || []).map((entry) => {
    if (entry.kind !== MISSION_SCRIPT_KINDS.REPLICA) {
      return entry;
    }
    return {
      ...entry,
      replica: {
        ...entry.replica,
        characterImage: entry.replica.characterImagePath || entry.replica.characterImage,
        characterImagePath: undefined,
      },
    };
  });

  const objectives = script
    .filter((entry) => entry.kind === MISSION_SCRIPT_KINDS.OBJECTIVE)
    .map((entry) => entry.objective);

  return {
    id: draft.id || 'mission_untitled',
    campaignFactionId: draft.campaignFactionId || null,
    order: draft.order || 1,
    title: draft.title || '',
    shortTitle: draft.shortTitle || draft.title || '',
    description: draft.description || '',
    finalRound: draft.finalRound ?? null,
    reward: draft.reward || null,
    rewardIfFactionOwned: draft.rewardIfFactionOwned || null,
    playerColor: draft.playerColor || null,
    players: draft.players || [],
    field: draft.field || null,
    policyMarket: draft.policyMarket || null,
    script,
    objectives,
  };
};

/** Сколько записей каждого вида — для подписи в панели редактора */
export const getMissionScriptStats = (script = []) => script.reduce((stats, entry) => {
  stats[entry.kind] = (stats[entry.kind] || 0) + 1;
  return stats;
}, {});

/** Скачивание конфига файлом — как сохранение поля в InGameMenu */
export const downloadMissionConfig = (mission) => {
  const json = JSON.stringify(mission, null, 2);
  const blob = new Blob([json], {type: 'application/json'});
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `${mission.id || 'mission'}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
